import {
	TYPE_TIERS_DEBITEUR_FOURNISSEUR,
	useUploadPjs,
} from '@mairistem/comptabilite';
import { FicheBar } from '@mairistem/fiche';
import React from 'react';

interface TiersFicheBarConsumerProps {
	identifiant?: number;
	onSaved?: any;
}

export const handleCreatingFicheTiers = (data) => ({
	...data,
	caduque: false,
	debiteurOuFournisseur: TYPE_TIERS_DEBITEUR_FOURNISSEUR,
});

const TiersFicheBarConsumer = ({
	identifiant,
	onSaved,
	...rest
}: TiersFicheBarConsumerProps) => {
	const uploadPjs = useUploadPjs();

	const handleSaved = (data, status) => {
		onSaved?.(data, status);
		uploadPjs(data?.identifiant);
	};

	return (
		<FicheBar
			{...rest}
			identifiant={identifiant}
			key="TiersFicheBarConsumer"
			onSaved={handleSaved}
			canDraft={false}
			type="tiers"
			onCreating={handleCreatingFicheTiers}
		/>
	);
};

export default TiersFicheBarConsumer;
